import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h6", null, "Log Absensi", -1)
const _hoisted_2 = { class: "text-black font-bold" }
const _hoisted_3 = {
  key: 0,
  class: "flex font-medium"
}
const _hoisted_4 = { class: "color-green" }
const _hoisted_5 = { class: "color-blue-grey" }
const _hoisted_6 = {
  key: 1,
  class: "font-medium"
}
const _hoisted_7 = {
  key: 0,
  class: "flex font-medium"
}
const _hoisted_8 = { class: "color-red" }
const _hoisted_9 = { class: "color-blue-grey" }
const _hoisted_10 = {
  key: 1,
  class: "font-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode(_component_DataTable, {
            value: _ctx.data,
            paginator: false,
            rows: _ctx.filters.top,
            stripedRows: "",
            class: "table-og",
            responsiveLayout: "scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Tanggal",
                style: {"width":"33%"}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("p", _hoisted_2, _toDisplayString(_ctx.moment(slotProps?.data?.CreateDate).format('dddd, DD MMMM YYYY')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Masuk",
                style: {"width":"33%"}
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.ClockIn)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode("p", _hoisted_4, _toDisplayString(`${_ctx.moment(slotProps?.data?.ClockIn).format('HH:mm')} WIB`) + " ", 1),
                        _createVNode("p", _hoisted_5, "(" + _toDisplayString(slotProps.data?.MsAgenIdInNavigation?.Nama) + ")", 1)
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_6, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Keluar",
                style: {"width":"33%"}
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.ClockOut)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("p", _hoisted_8, _toDisplayString(`${_ctx.moment(slotProps?.data?.ClockOut).format('HH:mm')} WIB`) + " ", 1),
                        _createVNode("p", _hoisted_9, "(" + _toDisplayString(slotProps.data?.MsAgenIdOutNavigation?.Nama) + ")", 1)
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_10, "-"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "rows"])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filters.top,
              totalRecords: _ctx.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}